var render, staticRenderFns
import script from "./SubscriberAvatar.vue?vue&type=script&lang=js&"
export * from "./SubscriberAvatar.vue?vue&type=script&lang=js&"
import style0 from "./SubscriberAvatar.vue?vue&type=style&index=0&id=2ab8d00e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab8d00e",
  null
  
)

export default component.exports